import { render, staticRenderFns } from "./ToiletBoxList.vue?vue&type=template&id=33d5aa34&scoped=true&lang=pug"
import script from "./ToiletBoxList.vue?vue&type=script&lang=ts"
export * from "./ToiletBoxList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5aa34",
  null
  
)

export default component.exports